<template>
  <div class="animated fadeIn">

    <!-- Main area -->
    <b-card>
      <div style="color: #2f353a;">
        <h2>Welcome to ChatAcuity</h2>
        <p>
          We see that you have just recently installed the app.  Because we have your privacy in mind, no workspace activity prior to installation is ever analyzed. Because of this, it can take a it can take approximately {{ minAge }} hours post-installation to generate meaningful insights from your event stream.
        </p>
        <p>
          Please check back soon!
        </p>
      </div>
      
    </b-card>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import { getStyle } from '@coreui/coreui-pro/dist/js/coreui-utilities'

export default {
  name: 'NewInstall',
  components: {
  },
  props: ['minAge'],
  data: function () {
    return {
      successColor: getStyle('--success'),
      dangerColor: getStyle('--danger')
    }
    
  },

  computed: {

  },
  
  methods: {

  },

  mounted() {

  }
}
</script>
